import {
  Box,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow
} from "@mui/material";
import moment from "moment";
import * as momentTimezone from "moment-timezone";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { Event } from "../../../interfaces/EventsInterface";
import { isResourceCentreUser } from "../../../containers/NavigationBar/SideBar";
import HandleBooking from "../../../containers/Calendar/Booking/HandleBooking";
import { EmptyView } from "../../OList";
import HandleBookingStatus from "../../../containers/Calendar/Booking/HandleBookingStatus";
import AssignServiceProvider from "../../../containers/Bookings/AssignServiceProvider";

interface PatientFlowListViewProps {
  selectedDate: Date | string;
  events: Event[];
}

export default function PatientFlowListView({
  selectedDate,
  events
}: PatientFlowListViewProps): JSX.Element {
  const startDate = momentTimezone(selectedDate).tz("Asia/Kathmandu").startOf("day").toISOString();
  const endDate = momentTimezone(selectedDate).tz("Asia/Kathmandu").endOf("day").toISOString();
  const userMode = useSelector((state: RootState) => state.userContext.mode);
  const filteredData = events
    .filter(
      (item) =>
        moment(item.start).isAfter(startDate) &&
        moment(item.start).isBefore(endDate) &&
        item.clientId
    )
    .sort((a, b) => a.id - b.id);

  return (
    <Box m={3}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 100, fontWeight: 600 }}>Time</TableCell>
              <TableCell sx={{ width: 200, fontWeight: 600 }}>Client</TableCell>
              <TableCell sx={{ width: 100, fontWeight: 600 }}>Phone</TableCell>
              <TableCell sx={{ width: 200, fontWeight: 600 }}>Service Provider</TableCell>
              <TableCell sx={{ width: 200, fontWeight: 600 }}>Reason</TableCell>
              <TableCell sx={{ width: 100, fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ width: 300, fontWeight: 600, textAlign: "right" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((event) => (
                <TableRow
                  key={event.id}
                  sx={{
                    "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                    "&:nth-of-type(even)": { backgroundColor: "#ffffff" },
                    "&:hover": { backgroundColor: "#f0f4ff" }
                  }}
                >
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Typography>{moment(event.start).format("h:mma")}</Typography>
                      {event.followUp && (
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            backgroundColor: "orange",
                            borderRadius: "50%",
                            mt: "5px",
                            ml: "3px",
                            flexShrink: 0
                          }}
                        />
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>{`${event.client?.firstName} ${event.client?.lastName}`}</TableCell>
                  <TableCell>{event.client?.phone}</TableCell>
                  <TableCell>
                    {event.serviceProvider ? (
                      `${event.serviceProvider?.firstName || ""} ${
                        event.serviceProvider?.lastName || ""
                      }`
                    ) : (
                      <AssignServiceProvider booking={event} />
                    )}
                  </TableCell>
                  <TableCell>{event.reasonOfVisit ? event.reasonOfVisit : "No reason"}</TableCell>
                  <TableCell>
                    <HandleBookingStatus booking={event} />
                  </TableCell>
                  <TableCell align="right">
                    {isResourceCentreUser(userMode) && (
                      <HandleBooking
                        booking={event}
                        serviceProvider={event.serviceProvider}
                        onClose={() => ({})}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7}>
                  <EmptyView>
                    <Box textAlign="center" padding="50px">
                      No items to show.
                    </Box>
                  </EmptyView>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
